module.exports = __webpack_public_path__ + "static/media/toilet-paper.14d40fc9.svg";